import {
  OccupancyInsightsTableFiltersActionTypes,
  OccupancyInsightsTableFiltersState,
  OccupancyInsightsTableFilters,
  SET_OCCUPANCY_INSIGHTS_TABLE_FILTERS
} from "store/reducers/occupancy-insights/occupancyInsightsTableFilters/types";

const defaultFilters: OccupancyInsightsTableFilters = {
  dates: 'NextWeek',
  fromDate: new Date(new Date().setHours(0, 0, 0, 0)),
  miles: 20,
  showAllReservations: false,
};

const defaultState: OccupancyInsightsTableFiltersState = {
  isLoading: false,
  errorMessage: "",
  contents: defaultFilters,
};

export default function occupancyInsightsTableFilters(state = defaultState, action: OccupancyInsightsTableFiltersActionTypes): OccupancyInsightsTableFiltersState {
  switch (action.type) {
    case SET_OCCUPANCY_INSIGHTS_TABLE_FILTERS:
      return {
        ...state,
        contents: {
          dates: action.contents.dates ?? state.contents.dates,
          fromDate: action.contents.fromDate ?? state.contents.fromDate,
          toDate: action.contents.toDate ?? state.contents.toDate,
          miles: action.contents.miles ?? state.contents.miles,
          showAllReservations: action.contents.showAllReservations ?? state.contents.showAllReservations
        },
        isLoading: false,
      };
    default:
      return state;
  }
}
